import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Swal from "sweetalert";

import { getProductosByCodeDetalle } from "../repository";

const ProductApplications = (props) => {
  const [productosDetalle, setProductosDetalle] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const codigo = props.codigo;

  useEffect(() => {
    buscaCodigo();
  }, []);

  const buscaCodigo = () => {
    getProductosByCodeDetalle(codigo)
      .then((response) => {
        if (response.status === "success") {
          setProductosDetalle(response.result);
          setIsLoading(false);
        } else {
          setProductosDetalle([]);
          Swal(
            "Error obtener la información [ProductosDetalle]",
            response.message,
            "error"
          );
        }
      })
      .catch((err) => {
        Swal("Error obtener la información [ProductosDetalle]", err, "error");
      });
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      props.closeModal();
    }
  };

  return ReactDOM.createPortal(
    <div className="image-zoom-overlay" onClick={handleBackdropClick}>
      <div className="image-zoom-modal" style={{ maxWidth: "800px" }}>
        <div className="image-zoom-header">
          <h5 className="image-zoom-title">
            <span className="badge badge-light ml-1 mr-1">
              {productosDetalle.length}
            </span>
            <small>
              {productosDetalle.length > 1 ? "Aplicaciones" : "Aplicación"}
              &nbsp;de:&nbsp;
            </small>
            <span className="badge badge-dark ml-1 mr-1">{codigo}</span>
          </h5>
          <button
            type="button"
            className="image-zoom-close"
            aria-label="Cerrar"
            onClick={props.closeModal}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="image-zoom-body product-apps-body">
          <div className="container-fluid w-100">
            <div className="row bg-secondary text-white py-2">
              <div className="col">
                <small><strong>Tipo</strong></small>
              </div>
              <div className="col">
                <small><strong>Modelo</strong></small>
              </div>
              <div className="col">
                <small><strong>Condición</strong></small>
              </div>
            </div>
            {isLoading ? (
              <div className="text-center py-3">
                <p>Cargando...</p>
                <div
                  className="spinner-border text-warning"
                  role="status"
                  aria-hidden="true"
                ></div>
              </div>
            ) : (
              productosDetalle.map((item, index) => (
                <div className="row bg-light border-bottom" key={index + codigo + item.Tipo + item.Modelos}>
                  <div className="col border-right">
                    <small>{`${index + 1}.- ${item.Tipo}`}</small>
                  </div>
                  <div className="col border-right">
                    <small>{item.Modelos}</small>
                  </div>
                  <div className="col">
                    <small>{item.Condicion}</small>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        <div className="image-zoom-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={props.closeModal}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ProductApplications;
